import React from "react";
import{useState,useEffect} from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/AthleteBio.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import { Helmet } from "react-helmet";
import AgencySidebar from "./AgencySidebar";



const AthleteBio =()=>{
    const [isLoading, setIsLoading] = useState(true);
    const location  = useLocation();
          const drupal_uid = localStorage.getItem('drupal_uid');
          const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
           var loggedin_domain = drupal_domain_url;
          if(localStorage.getItem('loggedin_domain')) {
            loggedin_domain = localStorage.getItem('loggedin_domain');
          } 
          var {uid} = useParams();
          var {username} = useParams();
          if(location.state) {
            uid = location.state;
          }
         
          const {tab} = useParams();
          
          const loggedin_uid = localStorage.getItem('uid');
          const navigate = useNavigate();
    
            const app_url = configData.APP_URL;
          
            const domain_url = configData.DOMAIN_URL;
            const [athleteInfo, setAthleteInfo] = useState({
  name: 'Anthony Turner',
  position: 'Wide Receiver',
});

    const mentors = [
  {
    name: "Adam Klimek",
    image: "/images/Adam.png",
    link: "",
    bio: ["SMWW Agency Director"]
  }, 
  {
    name: "Dr Lynn Lashbrook",
    image: "/images/person.jpg",
    link: "",
    bio: ["SMWW President & Founder", "Certified NFL Agent", "Former NCAA Athletic Director"]
  }
];
 const imagePath = "/images/Adam.png";
 const profileData = {
  dob: "Mar 13, 1998",
  age: 27,
  nationality: "American",
  height: "6 ft 4 in (193.04 cm)",
  weight: "218 lbs (98.88 kg)",
  sport: "Football (American)",
  college: "Green Bay Packers"
};
const socialLinks = [
  { name: "Twitter", url: "#", icon: "/images/twitter_logo_icon.png" }
];
const [bioData, setBioData] = useState({
  title: "Athlete Bio",
  paragraphs: [
    `Anthony Turner is a 6’4’’ Wide Receiver from Grand View University. Anthony is 2x All American as well as 2x Offensive Player of the Year in the NAIA. He also won the NAIA Championship with Grand View, scoring a 25-yard touchdown during the game.`,
    `You can read more about Anthony's journey to the NFL <a href="#">here</a>. Check out Anthony's interview with NFL Draft Diamonds <a href="#">here</a>.`,
    `Anthony is currently at Rookie Mini Camp with the Green Bay Packers, who he signed with after the 2022 NFL Draft.`,
  ],
  socialLinks: {
    Twitter: "@AnT80",
    Instagram: "@AJT.8",
  },
});
const [bioDetails, setBioDetails] = useState(true);
const [RepresentedBy, setRepresentedBy] = useState([]);
 const [errortext,  setErrorText] = useState('');
 const {slug} = useParams();
  useEffect(() => {
         Promise.all([
             retrieveAthleteBioDetails(),
             retrieveRepresentedBy()
         ])
         .then(() => {
      
         setIsLoading(false);
         })
      
     },[]);

  async function retrieveAthleteBioDetails() {
     if(slug) {
        try {
         
     const response = await fetch(
       app_url+'smwwathlete/getathletebiodetails?slug='+slug,
       {
         method: "GET",
   
         headers: {
           'Content-Type': 'application/json',
         },
       }
     )
     const responsedata = await response.json();
     if(responsedata.data.msg === "Success") {
       setBioDetails(responsedata.data.result);
     }
     if(responsedata.data.msg === "Error") {
       setErrorText(responsedata.data.result);
     }
     } catch (error) {
         console.error(error);
       }finally {
              // Set loading to false after fetch completes (success or error)
           }
   }
   }
   async function retrieveRepresentedBy() {
     if(slug) {
        try {
         
     const response = await fetch(
       app_url+'smwwathlete/getrepresentedby?slug='+slug,
       {
         method: "GET",
   
         headers: {
           'Content-Type': 'application/json',
         },
       }
     )
     const responsedata = await response.json();
     if(responsedata.data.msg === "Success") {
      setRepresentedBy(responsedata.data.result);
     }
     } catch (error) {
         console.error(error);
       }finally {
              // Set loading to false after fetch completes (success or error)
           }
   }
   }
   const handleExport = async (e) => {
    e.preventDefault(); // stop page reload
   
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'smwwathlete/downloadathletebio', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          slug:slug
        }),
      });
      const data = await response.json();
      const csvUrl = data.data.pdfUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                //link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };
    return (
           <>
                 {isLoading ? (
                      <Loading />
                    ) : (
        <div id="main" className="three-column-layout">
           <Helmet><title>{bioDetails.meta_title}</title></Helmet>
         {RepresentedBy.length > 0 && (
          <>
            <div className="left">
                <div className="view-content">
                    <h1>Represented By</h1>
                    <div className="item-list mentors-wrapper">
                        <ul>
                        {RepresentedBy.map((mentor, index) => (
                            <li key={index}>
                            <div className="views-field-picture">
                                <div className="field-content abc">
                                <a href={mentor.link}>
                                    <img
                                    typeof="foaf:Image"
                                    src={mentor.picture}
                                    width="193"
                                    height="158"
                                    alt={mentor.name}
                                    />
                                </a>
                                </div>
                            </div>
                            <div className="views-field-last-name">
                                <div className="field-content">
                                <a href={mentor.link} style={{ color: '#003c7d', fontSize: '18px',paddingLeft:"20px" }}>
                                    {mentor.name}
                                </a>
                                </div>
                            </div>
                            <div className="views-field-field-mentor-biography text">
                                <div className="field-content">
                                <div dangerouslySetInnerHTML={{ __html: mentor.bio }} />
                                </div>
                            </div>
                            </li>
                        ))}
                        </ul>
                    </div>
                </div>
            </div>
            </>
            )}
             <div className={(RepresentedBy.length > 0) ? 'center' : 'center left-center'}>
                {errortext ? (
                        <><div dangerouslySetInnerHTML={{ __html: errortext }}></div></>
                ) : (
                    <>
                <div className="newbio-container">
                        <table style={{ margin: '7% 0' }}>
      <tbody>
        <tr>
          <td className="mobile-bio-img" style={{ width: '50%' }}>
            <div className="image_container">
              <div
                style={{
                  width: "100%",
                  height: "100%",
                    background: `url(${bioDetails.picture}) center center / cover no-repeat`,
                   borderRadius:"50%", 
                }}
              >    
              </div>
            </div>
          </td>
          <td className="mobile-bio-name" style={{ width: '50%' }}>
           
            <div
  className="bio-name"
  style={{
    fontSize: '45px',
    fontWeight: 'bold',
    color: '#003c7d',
  }}
>
  {bioDetails.first_name}<br />
  {bioDetails.last_name}
</div>

<div
  style={{
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#003c7d',
    marginTop: '30px',
  }}
>
 {bioDetails.positions}
</div>

          </td>
        </tr>
      </tbody>
    </table>
   <div className="hr"></div>
   {(bioDetails.field_dob && bioDetails.field_nationality  && bioDetails.height  && bioDetails.weight 
                         && bioDetails.field_most_recent_college  && bioDetails.field_most_recent_seasons_stats  && bioDetails.field_career_information) && (
                          <>
<div className="profile-info-container">
  <div className="profile-info-row">
    {bioDetails.field_dob && (
    <div className="profile-info-cell">
      <b>Date of Birth:</b> {bioDetails.field_dob}
    </div>
    )}
    <div className="profile-info-cell">
      <b>Age:</b> {bioDetails.age}
    </div>
  </div>
{bioDetails.field_nationality && (
  <div className="profile-info-row">
    <div className="profile-info-cell full-width">
      <b>Nationality:</b> {bioDetails.field_nationality}
    </div>
  </div>
)}
  <div className="profile-info-row">
    {bioDetails.height && (
     
    <div className="profile-info-cell">
      <b>Height:</b> {bioDetails.height}
    </div>
    )}
     {bioDetails.weight && (
    <div className="profile-info-cell">
      <b>Weight:</b> {bioDetails.weight}
    </div>
    )}
  </div>

  <div className="profile-info-row">
    <div className="profile-info-cell full-width">
      <b>Sport:</b> {bioDetails.sport}
    </div>
  </div>
{bioDetails.field_most_recent_college && (
  <div className="profile-info-row">
    <div className="profile-info-cell full-width">
      <b>Most Recent College/Club:</b> {bioDetails.field_most_recent_college}
    </div>
  </div>
)}
</div>
{bioDetails.field_video_highlights && (
  <>
<div className="heading-wrapper">
  <h2>Video Hightlights</h2>
</div>

<div className="hr"></div>

<div className="season-stats-container">
   <div dangerouslySetInnerHTML={{ __html: bioDetails.field_video_highlights }} />
  
</div>
</>
)}
{bioDetails.field_most_recent_seasons_stats && (
  <>
<div className="heading-wrapper">
  <h2>Most Recent Season's Stats</h2>
</div>

<div className="hr"></div>

<div className="season-stats-container">
   <div dangerouslySetInnerHTML={{ __html: bioDetails.field_most_recent_seasons_stats }} />
  
</div>
</>
)}
{bioDetails.field_career_information && (
   <>
<div className="heading-wrapper">
  <h2>Career Highlights</h2>
</div>

<div className="hr"></div>

<div className="career-container">
  <div dangerouslySetInnerHTML={{ __html: bioDetails.field_career_information }} />
  
</div>
</>
)}

<div className="client-social-media">
  {(bioDetails.field_instagram_url  || bioDetails.field_instagram_handle  || bioDetails.field_facebook_url  || bioDetails.field_facebook_handle 
                         || bioDetails.field_twitter_url  || bioDetails.field_user_youtube_url  || bioDetails.field_linkedin_url  || bioDetails.field_linkedin_handle ) && (
                            <><div className="agent-heading-wrapper">
                                <h2>Social Media</h2>
                            </div>
                            <div className="hr"></div>
                            <div className="mobile-agent-sm-container" style={{width:"100%",display:"flex",flexWrap: "wrap"}}>
                                {bioDetails.field_instagram_url && (
                                  <div className="flex-child">
                                <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                  <img src="/basic/web/images/instagram_logo_icon.png" className="social-icon" style={{width:"20px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                         
                                            <div >
                                                
                                                <a href={bioDetails.field_instagram_url}>{bioDetails.field_instagram_handle}</a>
                                                {bioDetails.field_instagram_followers && (
                                                  <span className="sm-followers">
                                                    {bioDetails.field_instagram_followers}
                                                  </span>
                                                )} 
                                            </div>
                                              
                                     </div>
                                </div>
                                </div>
                                )}
                                {bioDetails.field_twitter_url && (
                                  <div className="flex-child">
                                <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                   <img src="/basic/web/images/twitter_logo_icon.png" className="social-icon" style={{width:"20px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                            
                                        
                                            <div >
                                               
                                                <a href={bioDetails.field_twitter_url}>{bioDetails.field_twitter_handle}</a>
                                                {bioDetails.field_twitter_followers && (
                                                  <span className="sm-followers">
                                                    {bioDetails.field_twitter_followers}
                                                  </span>
                                                )}
                                            </div>
                                    </div>
                                </div>   
                                     </div>
                                   )}
                                   {bioDetails.field_linkedin_url && (
                                    <div className="flex-child">
                                    <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                  <img src="/basic/web/images/linkedin_logo_icon.png" className="social-icon" style={{width:"20px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                            <div >
                                                
                                                <a href={bioDetails.field_linkedin_url}>{bioDetails.field_linkedin_handle}</a>
                                                 {bioDetails.field_linkedin_followers && (
                                                  <span className="sm-followers">
                                                    {bioDetails.field_linkedin_followers}
                                                  </span>
                                                )}
                                            </div>
                                     </div>
                                </div>     
                                    </div>
                                   )}
                                     {bioDetails.field_tiktok_url && (
                                    <div className="flex-child">
                                     <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                   <img src="/basic/web/images/tik_tok_new.png" className="social-icon" style={{width:"20px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                            <div >
                                               
                                                <a href={bioDetails.field_tiktok_url}>{bioDetails.field_tiktok_handle}</a>
                                                 {bioDetails.field_tiktok_followers && (
                                                  <span className="sm-followers">
                                                    {bioDetails.field_tiktok_followers}
                                                  </span>
                                                )}
                                            </div>
                                    </div>
                                     </div>     
                                     </div>
                                  )}
                                   {bioDetails.field_facebook_url && (
                                    <div className="flex-child">
                                   <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                  <img src="/basic/web/images/facebook_logo_icon.png" className="social-icon" style={{width:"20px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                            <div >
                                                
                                                <a href={bioDetails.field_facebook_url}>{bioDetails.field_facebook_handle}</a>
                                                 {bioDetails.field_facebook_followers && (
                                                  <span className="sm-followers">
                                                    {bioDetails.field_facebook_followers}
                                                  </span>
                                                )}
                                            </div>
                                       </div>
                                </div>     
                                  </div>
                                   )}
                                   {bioDetails.field_user_youtube_url && (
                                    <div className="flex-child">
                                     <div className="mobile-agent-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                   <img src="/basic/web/images/youtube_logo_icon.png" className="social-icon" style={{width:"20px"}} />
                                    <div style={{marginLeft:"15px"}}>
                                            <div >
                                               
                                                <a href={bioDetails.field_user_youtube_url}>{bioDetails.field_user_youtube_handle}</a>
                                                 {bioDetails.field_youtube_subscribers && (
                                                  <span className="sm-followers">
                                                    {bioDetails.field_youtube_subscribers}
                                                  </span>
                                                )}
                                            </div>
                                    </div>
                                     </div>     
                                     </div>
                                   )}
                                    </div>
                                 
                                   
                               </>
                         )}
</div>
{bioDetails.field_how_to_contact_client && (
  <>
<div className="heading-wrapper">
  <h2>How to Contact Client</h2>
</div>
<div className="hr"></div>
<div className="contact-client">
   <div dangerouslySetInnerHTML={{ __html: bioDetails.field_how_to_contact_client }} />
</div></>
)}
<br/>
<img id="print_pdf" src="/basic/web/images/pdf_icon_trans.png"  onClick={handleExport} style={{width:"40px",height:"49px",cursor:"pointer",marginTop:"20px"}}></img>
</>)}
                </div>
                </>
                    )}
  {bioDetails.field_biography && (
    <>
 <div className="oldbio-container">
  <div className="oldbio-container" style={{ marginTop: "5%", border: "1px solid #d2d4d4" }}>
    <table border="0" cellPadding="0" cellSpacing="0" className="bio-table">
      <tbody>
        <tr>
          <td colSpan="3" height="50px" valign="top" align="left" className="athlete-bio-td" style={{ backgroundColor: "#003c7d" }}>
            <div style={{ padding: "5px 0", marginLeft: "5px" }}>
              <h1 style={{ color: "white", margin: 0 }}>{bioData.title}</h1>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="bio-container" style={{ padding: "8px", wordBreak: "break-word" }}>
             
                <div dangerouslySetInnerHTML={{ __html: bioDetails.field_biography }} />
             
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</>
  )}
                <div className="view-content-tab">
                    <h1>Represented By</h1>
                    <div className="item-list mentors-wrapper">
                      <ul>
                        {RepresentedBy.map((mentor, index) => (
                            <li key={index}>
                            <div className="views-field-picture">
                                <div className="field-content abc">
                                <a href={mentor.link}>
                                    <img
                                    typeof="foaf:Image"
                                    src={mentor.picture}
                                    width="193"
                                    height="158"
                                    alt={mentor.name}
                                    />
                                </a>
                                </div>
                            </div>
                            <div className="views-field-last-name">
                                <div className="field-content">
                                <a href={mentor.link} style={{ color: '#003c7d', fontSize: '18px',paddingLeft:"20px" }}>
                                    {mentor.name}
                                </a>
                                </div>
                            </div>
                            <div className="views-field-field-mentor-biography text">
                                <div className="field-content">
                                <div dangerouslySetInnerHTML={{ __html: mentor.bio }} />
																  
														   
									   
									 
                                </div>
                            </div>
                            </li>
                        ))}
                        </ul>
                    </div>
                </div>


            </div>
            <div className="right">
                {/* <div className="right-form-item">
                    <h1>Agent & Athlete Search</h1>
                     <input
                                type="text"
                                name="agent_athlete_search"                             
                                style={{width:"100%"}}
                              />
                </div>
               <div className="right-form-item">
  <h1>About SMWW Agency</h1>
  <div className="">
    <div className="bio_content">
      <div className="bio_image">
        <img src="/basic/web/images/agency_logo.png" style={{width:"148px"}}alt="SMWW Agency" />
      </div>
      <div className="bio_heading">
        <h2 style={{padding:"0px",border:"none"}}>
          SMWW Agency represents, promotes, manages, and markets elite athletes around the world.
        </h2>
      </div>
      <div className="bio_text">
        At SMWW, we’ve developed a trained network of Agents, Scouts, and Analysts who provide unique
        information on a player’s ability/character and insights into the needs and requirements of
        teams and clubs.
      </div>
    </div>
  </div>
</div>

                <SalespersonSidebar/> */}
                 <AgencySidebar/>
                      <SalespersonSidebar /> 
                      {slug == "matt-moore" && (
                        <>
                          <p style={{ paddingTop: '15px' }}><img src="/basic/web/files/matt-moore-athlete-one.jpg" /></p>
                          <p><img src="/basic/web/files/matt-moore-athlete-two.jpg" /></p>
                          <p><img src="/basic/web/files/matt-moore-athlete-three.jpg" /></p>
                          <p><img src="/basic/web/files/matt-moore-athlete-four.jpg" /></p>
                          <p><img src="/basic/web/files/matt-moore-athlete-five.jpg" /></p>
                          <p><img src="/basic/web/files/matt-moore-athlete-six.jpg" /></p>
                          </>
                      )}
            </div>
        </div>
        )}
            </>
    );
};
export default AthleteBio;